import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Angulartics2Module } from 'angulartics2';
import { SelectLocationComponent } from './components/select-location.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        Angulartics2Module,
        MatAutocompleteModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule
     ],
    declarations: [
        SelectLocationComponent,
    ],
    exports: [
        SelectLocationComponent,
    ]
})
export class SelectLocationModule {}